import createSecureStorage from "Utils/Storage/createSecureStorage";
import type { SessionStorageKey } from "Utils/Storage/SessionStorage/SessionStorageKeys";

/**
 * Secure wrapper for sessionStorage operations with error handling
 * All operations are wrapped in try-catch blocks and log errors if they fail
 */

const storage = createSecureStorage<SessionStorageKey>(
  "sessionStorage",
  () => window.sessionStorage,
);

export const isSessionStorageAvailable = storage.isAvailable;
export const getSessionStorageItem = storage.getItem;
export const setSessionStorageItem = storage.setItem;
export const removeSessionStorageItem = storage.removeItem;
export const clearSessionStorage = storage.clear;
export const getSessionStorageJSON = storage.getJSON;
export const setSessionStorageJSON = storage.setJSON;
